class BaseService {
  isAvailable() {
    return true;
  }
}

export default BaseService;
